const customization_btn = document.querySelector('#custom__customization');
const nocustomization_btn = document.querySelector('#custom__no-customization');
const customization_block = document.querySelector('.product__customization');

const _customization_btn = document.querySelector('#custom__thay-dổi-chi-tiết');
const _nocustomization_btn = document.querySelector('#custom__thiết-kế-mặc-dịnh');
const __nocustomization_btn = document.querySelector('#custom__thiết-kế-mặc-dinh');


if(document.querySelector("input[name=Customization]:checked").value == 'Customization' )
  {
    customization_block.classList.remove('hide');
  }
  if(document.querySelector("input[name=Customization]:checked").value == 'No Customization' )
  {
   customization_block.classList.add('hide');
  }

if(document.querySelector("input[name=Customization]:checked").value == 'Chọn chữ cái tuỳ biến' )
  {
    customization_block.classList.remove('hide');
  }
  if(document.querySelector("input[name=Customization]:checked").value == 'Thiết kế mặc định' )
  {
   customization_block.classList.add('hide');
  }

if(customization_btn){
customization_btn.addEventListener('click', function(){
  customization_block.classList.remove('hide');
})
}
if(nocustomization_btn){

nocustomization_btn.addEventListener('click', function(){
  customization_block.classList.add('hide');
})}


if(_customization_btn){

_customization_btn.addEventListener('click', function(){
  customization_block.classList.remove('hide');
})
}
if(_nocustomization_btn){


_nocustomization_btn.addEventListener('click', function(){
  customization_block.classList.add('hide');
})}
if(__nocustomization_btn){


__nocustomization_btn.addEventListener('click', function(){
  customization_block.classList.add('hide');
})}


const customization = document.querySelectorAll('.customization__item');
const customization_box = document.querySelector('#customization__box');
customization.forEach((customization_item) => {
    customization_item.addEventListener('click', function(){
        const ele = customization_item.getAttribute('data-customization');
      const ele_text = customization_item.getAttribute('data-customization-text');
        customization_box.classList.remove('hide');
        customization_box.querySelector('#customization_text').value = ele_text;
        customization.forEach((customization_item) => {
            customization_item.classList.remove('current');
        });
        customization_item.classList.add('current');

        const customization__image = document.querySelector(".customization__image-" + ele.toLocaleLowerCase());
        const _customization__image = document.querySelectorAll(".customization__image");
        if (customization__image){
            _customization__image.forEach((_image) => {
                _image.classList.remove('active');
            });
            customization__image.classList.add('active');
            customization__image.scrollIntoView();
        }
        
    })
});
const _customization__image = document.querySelectorAll(".customization__image");
document.getElementById('clear__customization').addEventListener('click', function(){
  const liElement = document.querySelector('li input[value="Thiết kế mặc định"]').closest('li');
  const liElement_2 = document.querySelector('li input[value="Thay đổi chi tiết"]').closest('li');
  
  const input = liElement.querySelector('input');
  const label = liElement_2.querySelector('label');

  const clickEvent = new MouseEvent('click', {
    bubbles: true,
    cancelable: true,
    view: window
  });
  input.dispatchEvent(clickEvent);
  customization_block.classList.add('hide');
  label.classList.remove('active');
  
  customization_box.querySelector('#customization_text').innerText = '';
  customization_box.querySelector('#customization_text').value = '';
  customization_box.classList.add('hide');
  _customization__image.forEach((_image) => {
      _image.classList.remove('active');
  });
  customization.forEach((customization_item) => {
          customization_item.classList.remove('current');
  });
})